<template>
    <div class="container py-4">
        <div class="row">
            <div class="col-8">
                <h2 class="mb-4">New setting</h2>
                <router-link :to="{name: 'settingIndex'}" class="btn btn-outline-dark btn-sm mb-3">All settings
                </router-link>
            </div>
        </div>
        <div class="row">
            <div class="col-12 col-md-6">
                <div class="alert alert-success" role="alert" v-if="success">
                    Setting successfully created!
                </div>
                <div class="card">
                    <div class="card-body">
                        <form @submit.prevent="submit">
                            <div class="form-group">
                                <label for="option">Option*</label>
                                <input class="form-control" id="option" name="option"
                                       placeholder="Enter option"
                                       type="text"
                                       v-bind:class="[this.option.validated ? this.option.valid ? 'is-valid' : 'is-invalid' : '']"
                                       v-model="form.option"
                                       v-validate="'required'">
                                <div class="invalid-feedback">{{ errors.first('option') }}</div>
                            </div>
                            <div class="form-group">
                                <label for="value">Value*</label>
                                <input class="form-control" id="value" name="value"
                                       placeholder="Enter value"
                                       type="text"
                                       v-bind:class="[this.value.validated ? this.value.valid ? 'is-valid' : 'is-invalid' : '']"
                                       v-model="form.value"
                                       v-validate="'required'">
                                <div class="invalid-feedback">{{ errors.first('value') }}</div>
                            </div>
                            <button class="btn btn-primary" type="submit">Submit</button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import {mapFields} from 'vee-validate'
    import {mapGetters} from 'vuex'

    export default {
        name: 'settingCreate',
        data() {
            return {
                success: false,
                error: '',
                checkbox: true,
                form: {
                    option: '',
                    value: ''
                }
            }
        },
        computed: {
            ...mapFields(['option', 'value']),
            ...mapGetters(['SETTING'])
        },
        methods: {
            submit() {
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        //Moet in array voor backend
                        this.$store.dispatch('SAVE_SETTING', this.form)
                            .then(() => {
                                this.success = true
                                //Form leegmaken
                                this.form = {}
                                this.$validator.reset()
                            })
                            .catch((error) => {
                            })
                    }
                })
            },
            checkadmin() {
                console.log('test')
            }
        }
    }
</script>
